import moment from "moment";
import { DEMO_TURMA_DISC } from "./buildDemoOccurrences";
import { getDemoScheduleEventsForDayKey } from "./buildDemoTeacherSchedule";

/** Turma da rota demo (`/classes/DEMO-T1/...`), alinhada ao `classId` dos eventos do calendário. */
const DEMO_PLAN_CLASS_ID = "DEMO-T1";

const DEMO_CONTENTS = [
  "O lobo e o cordeiro - página 17 e 18 - escrita em trios",
  "Leitura e interpretação de notícia - Somativa 1",
  "Exploração de diferentes expressões culturais e patrimônios imateriais",
  "Dramatização - último ensaio antes da apresentação",
  "O sapo e o escorpião - coletivo",
  "Ortografia - revisão de dígrafos"
];

const LESSONS_PER_CONTENT = 2;

const savedLessonTexts = new Map();

function lessonsForDay(dayStr) {
  const events = [];
  for (let dayIndex = 0; dayIndex < 14; dayIndex += 1) {
    getDemoScheduleEventsForDayKey(dayStr, dayIndex)
      .filter(
        e => e.extendedProps && e.extendedProps.classId === DEMO_PLAN_CLASS_ID
      )
      .forEach(e => events.push(e));
  }

  return events
    .sort((a, b) => moment.utc(a.start).valueOf() - moment.utc(b.start).valueOf())
    .map((event, index) => {
      const start = moment.utc(event.start);
      const end = event.end
        ? moment.utc(event.end)
        : start.clone().add(50, "minutes");
      return {
        id: `${dayStr}-${index + 1}`,
        date: dayStr,
        lesson: String(index + 1),
        startTime: start.format("HH:mm"),
        endTime: end.format("HH:mm"),
        isPast: end.isBefore(moment())
      };
    });
}

function buildDemoContents(pastLessons) {
  const contents = [];
  for (let i = 0; i < pastLessons.length; i += LESSONS_PER_CONTENT) {
    contents.push({
      text: DEMO_CONTENTS[contents.length % DEMO_CONTENTS.length],
      lessonIds: pastLessons
        .slice(i, i + LESSONS_PER_CONTENT)
        .map(lesson => lesson.id)
    });
  }
  return contents;
}

function applySavedContents(contents, lessons) {
  const textByLesson = new Map();
  contents.forEach(content =>
    content.lessonIds.forEach(id => textByLesson.set(id, content.text))
  );
  savedLessonTexts.forEach((text, id) => textByLesson.set(id, text));

  const grouped = new Map();
  lessons.forEach(lesson => {
    const text = textByLesson.get(lesson.id);
    if (!text) return;
    if (!grouped.has(text)) grouped.set(text, { text, lessonIds: [] });
    grouped.get(text).lessonIds.push(lesson.id);
  });
  return Array.from(grouped.values());
}

/**
 * Grade do plano de aula para a demo (GET ClassDiaryV1/class/:classId/class-plan/grid).
 * Só há dados para a disciplina demo (Português); aulas já encerradas recebem conteúdo.
 */
export function buildDemoClassPlanGrid(idTurmaDisc, month) {
  const start = moment(month, "YYYY-MM", true);
  if (String(idTurmaDisc) !== String(DEMO_TURMA_DISC) || !start.isValid()) {
    return { lessons: [], contents: [] };
  }

  const lessons = [];
  for (let day = 1; day <= start.daysInMonth(); day += 1) {
    lessonsForDay(start.clone().date(day).format("YYYY-MM-DD")).forEach(
      lesson => lessons.push(lesson)
    );
  }

  return {
    lessons: lessons.map(({ isPast, ...lesson }) => lesson),
    contents: applySavedContents(
      buildDemoContents(lessons.filter(lesson => lesson.isPast)),
      lessons
    )
  };
}

/** Gravação simulada (POST ClassDiaryV1/class-plan/job), mantida em memória. */
export function saveDemoClassPlan({ contents = [], removals = [] }) {
  removals.forEach(removal =>
    removal.lessonIds.forEach(id => savedLessonTexts.set(id, null))
  );
  contents.forEach(content =>
    content.lessonIds.forEach(id => savedLessonTexts.set(id, content.text))
  );
}
